/* ============================================================
   The Rare Steps — Premium Contact interactions
   FAQ accordion · conditional form fields · validation ·
   submit/loading UX · scroll reveal. Vanilla, no deps.
   ============================================================ */
(function () {
  'use strict';

  if (window.__trsContactInit) return;
  window.__trsContactInit = true;

  document.documentElement.classList.add('trs-contact-ready');

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     Scroll reveal — adds .is-in when element enters the viewport
  ---------------------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.trs-c-reveal');
    if (!els.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    els.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms';
      io.observe(el);
    });
  }

  /* ---------------------------------------------------------------
     FAQ accordion — animated height, single-open optional,
     progressive enhancement over native <details>.
  ---------------------------------------------------------------- */
  function initFaq() {
    var lists = document.querySelectorAll('[data-trs-faq]:not([data-trs-faq-bound])');
    lists.forEach(function (list) {
      list.setAttribute('data-trs-faq-bound', '');
      var single = list.getAttribute('data-single-open') === 'true';
      var items = list.querySelectorAll('.trs-c-faq__item');

      items.forEach(function (item) {
        var summary = item.querySelector('.trs-c-faq__q');
        var panel = item.querySelector('.trs-c-faq__panel');
        if (!summary || !panel || summary.dataset.trsFaqBound) return;
        summary.dataset.trsFaqBound = 'true';

        // Custom accordion: keep <details open> in sync so content stays in layout.
        var startOpen = item.hasAttribute('open');
        if (!startOpen) item.removeAttribute('open');
        if (startOpen) openItem(item, panel);

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = item.classList.contains('is-open');
          if (single && !isOpen) {
            items.forEach(function (other) {
              if (other !== item && other.classList.contains('is-open')) {
                closeItem(other, other.querySelector('.trs-c-faq__panel'));
              }
            });
          }
          if (isOpen) {
            closeItem(item, panel);
          } else {
            openItem(item, panel);
          }
        });
      });
    });
  }

  function openItem(item, panel) {
    item.setAttribute('open', '');
    item.classList.add('is-open');
    var q = item.querySelector('.trs-c-faq__q');
    if (q) q.setAttribute('aria-expanded', 'true');
    panel.style.height = '';
    panel.style.height = panel.scrollHeight + 'px';
    var done = function () {
      panel.style.height = 'auto';
      panel.removeEventListener('transitionend', done);
    };
    if (prefersReduced) {
      panel.style.height = 'auto';
    } else {
      panel.addEventListener('transitionend', done);
    }
  }

  function closeItem(item, panel) {
    var q = item.querySelector('.trs-c-faq__q');
    if (q) q.setAttribute('aria-expanded', 'false');
    panel.style.height = panel.scrollHeight + 'px';
    void panel.offsetHeight;
    panel.style.height = '0px';
    item.classList.remove('is-open');
    item.removeAttribute('open');
  }

  /* ---------------------------------------------------------------
     Contact form — conditional fields, validation, submit UX
  ---------------------------------------------------------------- */
  var REASON_DEEP_LINKS = {
    customization: 'Customisation Request',
    customisation: 'Customisation Request',
    wedding: 'Wedding Order',
  };

  function scrollToContactTarget(target) {
    if (!target) return;
    window.requestAnimationFrame(function () {
      target.scrollIntoView({
        behavior: prefersReduced ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  }

  function applyContactDeepLink(reason, syncConditional) {
    var params = new URLSearchParams(window.location.search);
    var reasonKey = (params.get('reason') || '').toLowerCase();
    var mappedReason = REASON_DEEP_LINKS[reasonKey];
    var hash = window.location.hash;

    if (mappedReason) {
      reason.value = mappedReason;
      syncConditional();
    }

    if (hash === '#trs-customization-details' || reasonKey === 'customization' || reasonKey === 'customisation') {
      window.setTimeout(function () {
        scrollToContactTarget(
          document.getElementById('trs-customization-details') ||
            document.getElementById('trs-contact-form')
        );
      }, 120);
      return;
    }

    if (hash === '#trs-contact-form') {
      scrollToContactTarget(document.getElementById('trs-contact-form'));
    }
  }

  function initForm() {
    var form = document.querySelector('[data-trs-contact-form]:not([data-trs-form-bound])');
    if (!form) return;
    form.setAttribute('data-trs-form-bound', '');

    var reason = form.querySelector('[data-trs-reason]');
    var groups = form.querySelectorAll('[data-trs-when]');

    function syncConditional() {
      if (!reason) return;
      var value = reason.value;
      groups.forEach(function (group) {
        var when = (group.getAttribute('data-trs-when') || '').split('|');
        var active = when.indexOf(value) !== -1;
        group.classList.toggle('is-active', active);
        group.setAttribute('aria-hidden', active ? 'false' : 'true');
        group.querySelectorAll('input, select, textarea').forEach(function (el) {
          el.disabled = !active;
        });
      });
    }

    if (reason) {
      reason.addEventListener('change', syncConditional);
      syncConditional();
      applyContactDeepLink(reason, syncConditional);
    }

    var requiredFields = form.querySelectorAll('[data-trs-required]');
    requiredFields.forEach(function (input) {
      input.addEventListener('blur', function () {
        validateField(input);
      });
      input.addEventListener('input', function () {
        var field = input.closest('.trs-c-field');
        if (field && field.classList.contains('is-invalid')) validateField(input);
      });
    });

    form.addEventListener('submit', function (e) {
      var firstInvalid = null;
      requiredFields.forEach(function (input) {
        if (input.disabled) return;
        if (!validateField(input) && !firstInvalid) firstInvalid = input;
      });

      if (firstInvalid) {
        e.preventDefault();
        firstInvalid.focus();
        firstInvalid.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'center' });
        return;
      }

      var btn = form.querySelector('[data-trs-submit]');
      if (btn) btn.classList.add('is-loading');
    });

    var fileInput = form.querySelector('input[type="file"]');
    if (fileInput) {
      var hint = form.querySelector('[data-trs-file-hint]');
      var original = hint ? hint.textContent : '';
      fileInput.addEventListener('change', function () {
        if (!hint) return;
        hint.textContent = fileInput.files && fileInput.files.length
          ? fileInput.files[0].name
          : original;
      });
    }
  }

  function validateField(input) {
    var field = input.closest('.trs-c-field');
    if (!field) return true;
    var value = (input.value || '').trim();
    var valid = value.length > 0;

    if (valid && input.type === 'email') {
      valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    field.classList.toggle('is-invalid', !valid);
    input.setAttribute('aria-invalid', valid ? 'false' : 'true');

    // Programmatically associate the visible error text with the input so
    // screen readers announce the reason, not just "invalid" (WCAG 3.3.1).
    var error = field.querySelector('.trs-c-field__error');
    if (error) {
      if (!error.id) {
        error.id = (input.id || 'trs-c-field') + '-error';
      }
      if (valid) {
        input.removeAttribute('aria-describedby');
      } else {
        input.setAttribute('aria-describedby', error.id);
      }
    }
    return valid;
  }

  function init() {
    document.documentElement.classList.remove('no-js');
    initReveal();
    initFaq();
    initForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
